export enum SlotPosition {
  First = 0,
  Second = 1,
  Third = 2,
  Fourth = 3,
}
